import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';

export const useLogClickReviewMore = () => {
  const goodsSno = useGoodsSno();

  return useCallback(() => {
    bridge.logAnalyticsEvent({
      channel: ['amplitude', 'firebase'],
      name: 'CLICK_REVIEW_MORE',
      analytics: {
        SCREEN: 'GOODS_DETAIL',
        GOODS_SNO: goodsSno,
        POSITION: 'TOP',
      },
    });
  }, [goodsSno]);
};
